import React, { useEffect, useState } from "react";
import { numDifferentiation } from "../../utils";
export default function InvestmentSendMessage({ setMessage, message, sendAfterEnter, send, uploadFile, lastMessage, agentName, botName }) {
  const [disableInput, setDisableInput] = useState(false)
  const [monthlyExpense, isMonthlyExpense] = useState(false)
  const [loanInput, isLoneInput] = useState(false)
  const [error, setError] = useState(null)
  const validateMobile = (e) => {
    setMessage(e.target.value);
  }

  const handleKeyDown=(e)=>{
    setError(null)
    
    if (e.key == 'Enter') {
      sendAfterEnter(e)
  }
  }
  const sendMsg=(e)=>{
    send()

  }
  return (
    <>
      <div className="SendMsgContainer">
        <textarea
          value={message}
          style={{
            flex: 1,
            // marginTop: agentName ? 40 : -5
          }}
          maxLength={1000}
          placeholder={"Type your message here"}
          label=""
          disabled={!botName && !agentName}
          required
          onChange={(event) => validateMobile(event)}
          onKeyDown={(e) => handleKeyDown(e)}
        />
        {agentName ?
          <label className="fileInput">
            <input type={'file'} onChange={(event) => uploadFile(event.target.files)}></input>
          </label>
          : null}
        <button className="SendMsgbutton disable" onClick={sendMsg}>Send</button>
      </div>
    </>
  );
}
